export default __webpack_public_path__ + "static/media/BQ.83d64f2b.png";